
import axios from 'axios';
import { AxiosCreateResponse, CreateResponse, DeleteResponse, FilterDto, GetAllResponse } from "@ontime/types";
import AuthHeader from './AuthHeader';
import ApiURL from './ApiURL';
import { handleError } from './HandleError';
import { UserFavoriteOrganizationByOrganizationIdFilterDto, UserFavoriteOrganizationByOrganizationId, UserFavoriteOrganizationFilterDto, UserFavoriteOrganizationRequest, UserFavoriteOrganization } from "@ontime/types";


const API_URL = ApiURL() + 'services/app/userFavoriteOrganization';

class UserFavoriteOrganizationService {

    GetAll(userFavoriteOrganizationFilterDto: UserFavoriteOrganizationFilterDto, filterDto: FilterDto) {
        return axios.get<GetAllResponse<UserFavoriteOrganization>>(API_URL + "/GetAll", {
            params: { ...userFavoriteOrganizationFilterDto, ...filterDto },
            headers: AuthHeader()
        });
    }

    async Create(input: UserFavoriteOrganizationRequest): Promise<CreateResponse<UserFavoriteOrganization>> {
        return axios.post<AxiosCreateResponse<UserFavoriteOrganization>>(API_URL + '/Create', input, {
            headers: AuthHeader()
        })
            .then(response => {
                return {
                    success: true,
                    response: response.data
                };
            })
            .catch((error) => handleError(error, 'Save error, please check your internet connection.'));
    }

    // async Update(input: UserFavoriteOrganizationRequest): Promise<CreateResponse<UserFavoriteOrganization>> {
    //     return axios.put<AxiosCreateResponse<UserFavoriteOrganization>>(API_URL + '/Update', input, {
    //         headers: AuthHeader()
    //     })
    //         .then(response => {
    //             return {
    //                 success: true,
    //                 response: response.data
    //             };
    //         })
    //         .catch((error) => handleError(error, 'Update error, please check your internet connection.'));
    // }

    async Delete(id: number): Promise<{ response: DeleteResponse }> {
        return axios.delete<DeleteResponse>(API_URL + '/Delete', {
            params: { id },
            headers: AuthHeader()
        })
            .then(response => {
                return {
                    success: true,
                    response: response.data
                };
            })
            .catch((error) => handleError(error, 'Delete error, please check your internet connection.'));

    }

    // Get(id: number) {
    //     return axios.get<GetResponse<UserFavoriteOrganization>>(API_URL + "/Get", {
    //         params: { id },
    //         headers: AuthHeader(),
    //     })
    //         .then((response) => ({
    //             success: true,
    //             response: response.data,
    //         }))
    //         .catch((error) => handleError(error, 'Error retrieving the userFavoriteOrganization, please check your connection.'));
    // }

    GetAllByOrganizationId(clientFilterDto: UserFavoriteOrganizationByOrganizationIdFilterDto, filterDto: FilterDto) {
        return axios.get<GetAllResponse<UserFavoriteOrganizationByOrganizationId>>(API_URL + "/GetAllByOrganizationId", {
            params: { ...clientFilterDto, ...filterDto },
            headers: AuthHeader()
        });
    }
}

export default new UserFavoriteOrganizationService();